import styled from 'styled-components';
import { colors, font, spacing } from '@chegg-ui/theme';
export var CheckBoxLabel = styled.label.withConfig({
  componentId: "sc-133q48z-0"
})(["font-family:", ";font-size:", ";color:", ";padding:0px;padding-bottom:", ";display:block;font-weight:", ";line-height:", ";"], font.family.aspira, font.size.px14, colors.grey900, spacing.px8, font.weight.bold, font.lineHeight.sm);
export var CheckBoxGroupWithInput = styled.div.withConfig({
  componentId: "sc-133q48z-1"
})(["margin-bottom:", ";"], spacing.px16);